import { createTheme } from "@mui/material";

export const myPalette = {
  primary: { light: "#4D9FEC", main: "#0075E3", dark: "#005AB8" },
  secondary: { light: "#F4A85C", main: "#EF8C23", dark: "#D67515" },
  grey: { light: '#e8e8e8', main: '#ccc', dark: '#434343' },
  yellow: { light: "#FFFEA9", main: "#FBDF46", dark: "#F7BD4D" },
  error: { main: "#E53935" },
  erroralert: { main: "rgba(255, 0, 0, 0.6)" },
  success: { main: "#388E3C" },
  successalert: { main: "rgba(46, 125, 50,0.7)" },
  bleu: { light: '#C5CAE9', main: '#3F51B5', dark: "#0E073A" },
  background: {
    default: "#fbf9f9ff",
    secondary: "#f8fafc",
    paper: "#FFFFFF",
    table: "#141416",
    inputs: "#FFFFFF",
    cardBackground: "#f8f8f8",
    sidebar: "#1A1A1C",
    hover: "#252527"
  },
  border: {
    light: "#3c85e5ff",
    // hover : "#005AB8",
    // focused : "#1976d2",
    medium: "#B2B2B2",
    dark: "#3D5F8A"
  },
  text: { primary: '#19222B', secondary: '#666666', muted: '#999999' },
  icons: {
    primary: "#000000",
    secondary: "#475569",
    muted: "#8E8E93"
  }
};

export const myPaletteDark = {
  primary: { light: "#5CA3F5", main: "#1E88E5", dark: "#0075E3" },
  secondary: { light: "#FFB366", main: "#FF9F3D", dark: "#EF8C23" },
  grey: { light: "#4A5D7A", main: "#8CA5C4", dark: "#C5D7E8" },
  yellow: { light: "#FFE082", main: "#FFD54F", dark: "#FFCA28" },
  error: { main: "#EF5350" },
  erroralert: { main: "rgba(239, 83, 80, 0.7)" },
  success: { main: "#66BB6A" },
  successalert: { main: "rgba(102, 187, 106, 0.7)" },
  bleu: { light: "#90CAF9", main: "#42A5F5", dark: "#1976D2" },
  background: {
    default: "#0A1628",
    secondary: "#0F1E33",
    paper: "#132844",
    cardbg: "#1A3552",
    cardBackground: "#162B44",
    inputs: "#162B44",
    table: "#0D1B2E",
    sidebar: "#0F2341",
    hover: "#16304D"
  },
  text: {
    primary: "#E5E7EB",
    secondary: "#94B3D4",
    disabled: "#666666",
    muted: "#B8D4EB"
  },
  border: {
    light: "#1E3A5F",
    medium: "#2A4C75",
    dark: "#3D5F8A"
  },
  status: {
    admin: "#5CA3F5",
    agent: "#4DD0E1"
  },
  icons: {
    primary: "#E8F1FA",
    secondary: "#94B3D4",
    muted: "#B8D4EB"
  }
};

export const reusableStyles = {
  // Border radius standards
  borderRadius: {
    small: '4px',
    medium: '12px',
    large: '16px',
  },

  // Transitions standards
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.2s ease',
    slow: 'all 0.4s ease',
  },

  // Gradients réutilisables
  gradients: {
    purple: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    purpleHover: 'linear-gradient(135deg, #5568d3 0%, #653a8b 100%)',
    primary: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
    primaryHover: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
  },

  // Box shadows standards
  boxShadows: {
    light: '0 4px 12px rgba(0, 0, 0, 0.08)',
    medium: '0 4px 12px rgba(102, 126, 234, 0.15)',
    heavy: '0 20px 60px rgba(0, 0, 0, 0.15)',
    button: '0 4px 14px rgba(224, 116 , 0, 0.3)',
  },

  // Scrollbar styles
  scrollbar: (mode) => ({
    '&::-webkit-scrollbar': {
      width: '5px',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: mode === 'dark' ? '#2C2C2E' : '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: mode === 'dark' ? '#48484A' : '#c1c1c1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: mode === 'dark' ? '#5E5E60' : '#a8a8a8',
    },
  }),
};

const getSharedConfig = (mode) => ({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    fontOpticalSizing: 'auto',
    fontWeight: 400,
    fontVariantNumeric: 'tabular-nums',
    fontStyle: 'normal',
    button: {
      fontSize: 13,
      fontWeight: "bold",
    },
    h6: {
      fontSize: "16px",
      fontWeight: "600",
    },
  },
  zIndex: {
    mobilestepper: 1000,
    fab: 1050,
    speeddial: 1050,
    appbar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: "0 !important",
          borderRadius: '8px',
          backgroundColor: mode === 'dark'
            ? myPaletteDark.background.inputs
            : myPalette.background.inputs,
          height: '30px',
          minHeight: '30px',

          // '&:hover': {
          //   backgroundColor: mode === 'dark'
          //     ? 'rgba(255, 255, 255, 0.12)'
          //     : '#eeeeee',
          // },

          // '&.Mui-focused': {
          //   backgroundColor: mode === 'dark'
          //     ? 'rgba(255, 255, 255, 0.12)'
          //     : '#eeeeee',
          // },

          '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
          },

          '& .MuiIconButton-root': {
            padding: "0px"
          },
        },

        input: {
          '@media (min-width: 600px)': {  // sm
            fontSize: '11px',
          },
          '@media (min-width: 900px)': {  // md
            fontSize: '12px',
          },
          '@media (min-width: 1200px)': { // lg
            fontSize: '12px',
          },
          '@media (min-width: 1500px)': { // xl
            fontSize: '13px',
          },
          '@media (min-width: 1900px)': { // xxl
            fontSize: '14px',
          },
          // margin: "2px !important",
          padding: "2px 8px !important",
          height: '100%',
          color: mode === 'dark' ? myPaletteDark.text.primary : myPalette.text.primary,
          backgroundColor: 'transparent',

          '&:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 100px ${mode === 'dark' ? myPaletteDark.background.inputs : myPalette.background.inputs} inset`,
            WebkitTextFillColor: mode === 'dark' ? '#fff' : '#000',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        },

        notchedOutline: {
          borderColor: mode === 'dark'
            ? myPaletteDark.border.medium
            : myPalette.border.medium,

          // Border states
          '.MuiOutlinedInput-root:hover &': {
            borderColor: mode === 'dark' ? myPaletteDark.primary.main : myPalette.primary.main,
          },

          '.MuiOutlinedInput-root.Mui-focused &': {
            borderColor: mode === 'dark' ? myPaletteDark.primary.main : myPalette.primary.main,
            borderWidth: '2px',
          },
        }
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          marginRight: "0 !important",
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark'
            ? 'rgba(255, 255, 255, 0.09)'
            : '#f5f5f5',
          // '&:hover': {
          //   backgroundColor: mode === 'dark'
          //     ? 'rgba(255, 255, 255, 0.12)'
          //     : '#eeeeee',
          // },
          // '&.Mui-focused': {
          //   backgroundColor: mode === 'dark'
          //     ? 'rgba(255, 255, 255, 0.12)'
          //     : '#eeeeee',
          // },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
          }
        }
      }
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          height: '30px !important',
          minHeight: '30px',
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          color: mode === 'dark' ? 'var(--grey-light)' : 'var(--grey-dark)',
          transition: 'all 0.2s ease',
          fontSize: '12px',
          '@media (min-width: 600px)': {  // sm
            fontSize: '13px',
          },
          '@media (min-width: 1200px)': { // lg
            fontSize: '14px',
          },
          '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            transform: 'translate(14px, 9px) scale(1)',
            top: '-3px',
            '@media (min-width: 600px)': {
              top: '-4px',
            },
            '@media (min-width: 900px)': {
              top: '-3px',
            },
            '@media (min-width: 1200px)': {
              top: '-4px',
            },
            '@media (min-width: 1800px)': {
              top: '-5px',
            },
          },
          '.with-start-icon &.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            transform: 'translate(35px, 9px) scale(1)',
            top: '-3px',
            '@media (min-width: 600px)': {
              top: '-4px',
            },
            '@media (min-width: 900px)': {
              top: '-3px',
            },
            '@media (min-width: 1200px)': {
              top: '-4px',
            },
            '@media (min-width: 1800px)': {
              top: '-5px',
            },
          },
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, 0px) scale(0.75)',
            top: "-10px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: '30px',
          minHeight: '30px',
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: "8px !important",
          boxShadow: 'none',
          '@media (min-width: 600px)': {  // sm
            fontSize: '11px',
          },
          '@media (min-width: 900px)': {  // md
            fontSize: '12px',
          },
          '@media (min-width: 1200px)': { // lg
            fontSize: '12px',
          },
          '@media (min-width: 1500px)': { // xl
            fontSize: '13px',
          },
          '@media (min-width: 1900px)': { // xxl
            fontSize: '14px',
          },
          // '&.MuiButton-containedPrimary': {
          //   background: 'var(--primary-main)',
          //   // boxShadow: '0 4px 14px rgba(25, 118, 210, 0.3)',
          //   '&:hover': {
          //     background: 'var(--primary-dark)',
          //     // boxShadow: '0 6px 20px rgba(25, 118, 210, 0.4)',
          //   },
          // },
        },
      },
      // Variants pour boutons personnalisés
      variants: [
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            background: 'var(--secondary-main)',
            color: 'white',
            height: '30px',
            minHeight: '30px',
            boxShadow: 'none',
            borderRadius: reusableStyles.borderRadius.small,
            '&:hover': {
              background: 'var(--secondary-dark)',
              boxShadow: reusableStyles.boxShadows.button,
            },
            '&:disabled': {
              background: '#FFE0CE',
              color: '#D4B8AA',
            },
          },
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            background: 'var(--secondary-main)',
            color: 'white',
            height: '30px',
            minHeight: '30px',
            boxShadow: 'none',
            borderRadius: reusableStyles.borderRadius.small,
            '&:hover': {
              background: 'var(--secondary-dark)',
              boxShadow: reusableStyles.boxShadows.button,
            },
            '&:disabled': {
              background: '#FFE0CE',
              color: '#D4B8AA',
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            backgroundColor: mode === 'dark' ? 'rgba(28, 28, 30, 0.5)' : 'transparent',
            border: `1px solid ${mode === 'dark' ? myPaletteDark.border.medium : "var(--primary-main)"}`,
            color: mode === 'dark' ? 'var(--grey-light)' : 'var(--primary-main)',
            borderRadius: reusableStyles.borderRadius.small,
            padding: '8px 16px',
            height: '30px',
            minHeight: '30px',
            '&:hover': {
              backgroundColor: 'white',
            },
            '&:disabled': {
              borderColor: mode === 'dark' ? myPaletteDark.grey.main : myPalette.grey.main,
              color: mode === 'dark' ? myPaletteDark.grey.dark : 'rgba(0, 0, 0, 0.26)',
            },
            '& .MuiButton-startIcon': {
              marginRight: '8px',
              marginLeft: '-4px',
            },
            '& .MuiButton-endIcon': {
              marginLeft: '8px',
              marginRight: '-4px',
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'warning' },
          style: {
            backgroundColor: mode === 'dark' ? 'rgba(28, 28, 30, 0.5)' : 'white',
            border: `1px solid ${mode === 'dark' ? myPaletteDark.border.medium : "var(--secondary-main)"}`,
            color: mode === 'dark' ? 'var(--grey-light)' : 'var(--secondary-main)',
            borderRadius: reusableStyles.borderRadius.small,
            padding: '8px 16px',
            height: '30px',
            minHeight: '30px',
            '&:hover': {
              backgroundColor: 'white',
            },
            '&:disabled': {
              borderColor: mode === 'dark' ? myPaletteDark.grey.main : myPalette.grey.main,
              color: mode === 'dark' ? myPaletteDark.grey.dark : 'rgba(0, 0, 0, 0.26)',
            },
            '& .MuiButton-startIcon': {
              marginRight: '8px',
              marginLeft: '-4px',
            },
            '& .MuiButton-endIcon': {
              marginLeft: '8px',
              marginRight: '-4px',
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'secondary' },
          style: {
            backgroundColor: mode === 'dark' ? 'rgba(28, 28, 30, 0.5)' : 'transparent',
            border: `1px solid ${mode === 'dark' ? myPaletteDark.border.medium : myPalette.grey.main}`,
            color: mode === 'dark' ? 'var(--grey-light)' : 'var(--grey-dark)',
            borderRadius: reusableStyles.borderRadius.small,
            padding: '8px 16px',
            height: '30px',
            minHeight: '30px',
            '&:hover': {
              backgroundColor: 'transparent',
              borderColor: mode === 'dark' ? 'white' : 'black',
            },
            '&:disabled': {
              borderColor: mode === 'dark' ? myPaletteDark.grey.main : myPalette.grey.main,
              color: mode === 'dark' ? myPaletteDark.grey.dark : 'rgba(0, 0, 0, 0.26)',
            },
            '& .MuiButton-startIcon': {
              marginRight: '8px',
              marginLeft: '-4px',
            },
            '& .MuiButton-endIcon': {
              marginLeft: '8px',
              marginRight: '-4px',
            },
          },
        },
      ],
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          backgroundColor: 'transparent',
          color: mode === 'dark' ? 'var(--grey-light)' : 'var(--grey-dark)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '16px !important',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          overflow: 'hidden !important',
          maxWidth: 'none !important',
          background: mode === 'dark' ? '#1C1C1E' : '#F9FAFB',
          border: mode === 'dark' ? '1px solid #2C2C2E' : 'none'
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '5px 10px',
          gap: 1,
          borderTop: mode === 'dark' ? '1px solid #2C2C2E' : '1px solid #E5E7EB',
          backgroundColor: mode === 'dark' ? myPaletteDark.background.paper : myPalette.background.paper,
        }
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 20px',
          borderBottom: '1px solid',
          borderColor: mode === 'dark' ? '#2C2C2E' : '#E5E7EB',
          height: '45px',
          background: mode === 'dark'
            ? myPaletteDark.primary.dark
            : myPalette.primary.main,
          color: mode === 'light' ? '#FFFFFF' : '#111827',
          fontSize: '1rem',
          lineHeight: 1.3,
        },
      },
      title: {
        flex: '1',
        textAlign: 'center',
        margin: 'auto',
      },
    },
    MuiBoxRoot: {
      maxWidth: "unset !important",
      backgroundColor: 'transparent !important',
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '16px 24px !important',
          // backgroundColor: mode === 'dark' ? '#1C1C1E' : 'var(--body-grey) ',
          backgroundColor: 'var(--background-container)',
          color: mode === 'dark' ? '#FFFFFF' : '#111827',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          backgroundImage: 'none',
          // marginBottom: '6px',
        },
      },
      // Variants pour Paper personnalisés
      variants: [
        {
          props: { variant: 'section' },
          style: {
            padding: '16px',
            borderRadius: reusableStyles.borderRadius.medium,
            border: "var(--color-border)",
            backgroundColor: mode === 'dark' ? '#1C1C1E' : 'white',
            transition: reusableStyles.transitions.default,
            '&:hover': {
              boxShadow: reusableStyles.boxShadows.light,
            },
          },
        },
        {
          props: { variant: 'highlighted' },
          style: {
            padding: '16px',
            borderRadius: reusableStyles.borderRadius.medium,
            border: '1px solid',
            borderColor: mode === 'dark' ? myPaletteDark.primary.main : myPalette.primary.main,
            backgroundColor: mode === 'dark' ? '#1C1C1E' : 'white',
            transition: reusableStyles.transitions.default,
            '&:hover': {
              boxShadow: reusableStyles.boxShadows.medium,
            },
          },
        },
      ],
    },
    MuiChip: {
      // Variants pour Chip personnalisés
      variants: [
        {
          props: { variant: 'status' },
          style: {
            backgroundColor: mode === 'dark' ? myPaletteDark.primary.main : myPalette.primary.main,
            color: 'white',
            border: '1px solid',
            borderRadius: '50px',
            height: "18px",
            "& .MuiChip-label": {
              fontWeight: 600,
              '@media (min-width: 0px)': {  //xs
                fontSize: '10px',
              },
              '@media (min-width: 1200px)': { // lg
                fontSize: '11px',
              },
              '@media (min-width: 1536px)': { // xl
                fontSize: '12px',
              },
              fontSize: { xs: '10px !important', lg: '11px !important', xl: "14px !important" },
            }
          },
        },
      ],
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '12px',
        },
      },
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          display: 'flex',
          backgroundsize: 'cover',
          backgroundrepeat: 'no-repeat',
          backgroundposition: ' center',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: mode === 'dark' ? '#1C1C1E' : undefined,
          borderBottom: mode === 'dark' ? '1px solid #2C2C2E' : undefined,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: mode === 'dark' ? myPaletteDark.background.cardBackground : myPalette.background.cardBackground,
          border: mode === 'dark' ? '1px solid #2C2C2E' : 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '9px',
          borderBottom: mode === 'dark' ? '1px solid #2C2C2E' : undefined,
          color: mode === 'dark' ? '#FFFFFF' : undefined,
        },
        head: {
          backgroundColor: mode === 'dark' ? '#1C1C1E' : undefined,
          color: mode === 'dark' ? '#B8B8B8' : undefined,
          fontWeight: 600,
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark' ? '#141416' : undefined,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: mode === 'dark' ? '#1F1F21 !important' : undefined,
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: mode === 'dark' ? '#1A1A1C' : undefined,
          borderRight: mode === 'dark' ? '1px solid #2C2C2E' : undefined,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          overflow: 'visible',
          marginTop: '8px',
          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 12,
            width: 10,
            height: 10,
            backgroundColor: mode === "dark" ? "#1E2433" : "#FFFFFF",
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: mode === 'dark' ? '#2C2C2E' : undefined,
          },
          '&.Mui-selected': {
            backgroundColor: mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : undefined,
            '&:hover': {
              backgroundColor: mode === 'dark' ? 'rgba(33, 150, 243, 0.15)' : undefined,
            },
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          MuiButton: {
            root: {
              lineheight: '0 !important',
              alignItems: 'center',
            }
          }
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': { display: 'none' },
          boxShadow: 'none',
          border: '1px solid var(--color-border)',
          borderRadius: '16px !important',
          backgroundColor: mode === 'dark' ? myPaletteDark.background.paper : 'myPalette.background.paper',
          '&.Mui-expanded': {
            margin: 0,
            padding: 0,
          },
          '&:hover': {
            boxShadow: 'none !important',
          },
          '&:has(:focus-visible)': {
            borderColor: mode === 'dark' ? myPaletteDark.primary.main : 'var(--primary-main)',

          },
        },
      },
      // Variants pour les accordions personnalisés
      variants: [
        {
          props: { variant: 'required' },
          style: {
            borderColor: mode === 'dark' ? myPaletteDark.primary.main : 'var(--primary-main)',
            '&:has(:focus-visible)': {
              borderColor: mode === 'dark' ? myPaletteDark.primary.main : 'var(--primary-main)',
            },
          },
        },
        {
          props: { variant: 'optional' },
          style: {
            border: "1px solid var(--color-border)",
            borderColor: mode === 'dark' ? myPaletteDark.border.medium : '#e0e0e0',
            '&:has(:focus-visible)': {
              borderColor: mode === 'dark' ? myPaletteDark.primary.main : 'var(--primary-main)',

            },
          }
        },
      ],
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          marginTop: '15px !important',
          marginBottom: '15px !important',
          minHeight: '30px',
          alignItems: 'center',
          '&.Mui-expanded': {
            marginTop: '15px !important',
            marginBottom: '0px !important',
            minHeight: '30px',
          },
          '& .MuiAccordionSummary-content': {
            // alignItems: 'center',
            margin: '0 !important',
            gap: '8px',
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '0 !important',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '16px',
          marginBottom: '12px',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          '& .MuiGrid-item': {
            paddingLeft: '10px',
            paddingTop: '10px',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '4px',
          '&.Mui-checked': {
            color: mode === 'dark' ? myPaletteDark.primary.main : myPalette.primary.main,
          },
          '&.Mui-disabled': {
            color: mode === 'dark' ? myPaletteDark.grey.main : myPalette.grey.main,
          }
        },
        sizeSmall: {
          padding: '2px',
          '& .MuiSvgIcon-root': {
            fontSize: '1rem',
            width: '1em',
            height: '1em',
          }
        }
      },
      defaultProps: {
        size: 'small',
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '4px',
          '& .MuiSvgIcon-root': {
            width: '0.6em',
            height: '0.6em',

            // lg
            '@media (min-width:1200px)': {
              width: '0.8em',
              height: '0.8em',
            },

            // xl
            '@media (min-width:1536px)': {
              width: '0.8em',
              height: '0.8em',
            },
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: '16px',
          marginLeft: 0,
          '&:last-child': {
            marginRight: 0
          },
          "& .MuiFormControlLabel-label": {
          },
        },
        label: {
          fontSize: '12px',
          '@media (min-width:1200px)': {
            fontSize: '13px',
          },

          // xl
          '@media (min-width:1536px)': {
            fontSize: '14px',
          },
          fontWeight: 400,
          // color: mode === 'dark' ? myPaletteDark.text.secondary : myPalette.text.secondary,
          '&.Mui-disabled': {
            color: mode === 'dark' ? myPaletteDark.text.disabled : 'rgba(0, 0, 0, 0.38)',
          }
        }
      }
    },
    // MuiRadioGroup: {
    //   styleOverrides: {
    //     root: {
    //       '&.MuiFormGroup-row': {
    //         margin: '0 -4px',
    //       }
    //     }
    //   }
    // },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          marginBottom: '10px',
          gap: '10px',
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: 0,
          width: '100%',
          fontSize: '1rem',
          // color: mode === 'dark' ? myPaletteDark.text.primary : myPalette.text.primary,
        }
      }
    },
  },
  overrides: {
    MuiButton: {
      root: {
        height: '30px',
        minHeight: '30px',
      },
      containedSecondary: {
        color: 'white',
        backgroundColor: '#F18C20',
        '&:hover': {
          backgroundColor: '#F18C20',
        },
      },
    },
    MuiAutocomplete: {
      root: {
        padding: "0",
        paddingLeft: '10px !important',
        height: '30px',
        minHeight: '30px',
      },
      paper: {
        width: 'fit-content',
        minWidth: '100%',
        overflow: 'visible',
        whiteSpace: "nowrap !important",
        fontSize: '13px !important',
        backgroundColor: mode === 'dark' ? '#1C1C1E' : 'white',
        border: mode === 'dark' ? '1px solid #2C2C2E' : undefined,
      },
      option: {
        background: mode === 'dark' ? '#1C1C1E !important' : 'white !important',
        '&[data-focus="true"]': {
          backgroundColor: mode === 'dark' ? '#2C2C2E !important' : '#eee !important',
        },
      },
      tag: {
        margin: '6px',
        backgroundColor: mode === 'dark' ? '#2C2C2E' : undefined,
        color: mode === 'dark' ? '#FFFFFF' : undefined,
      },
    },
  },
});

//build theme depending on mode light or dark , to use it just call getAppTheme(dark)
export const getAppTheme = (mode = 'light' , lang = 'fr') => {
  const isDark = mode === 'dark';
  const palette = isDark ? myPaletteDark : myPalette;
  return createTheme({
    direction: 'ltr',
    palette: {
      mode: mode,
      ...palette,
      background: {
        default: palette.background?.default,
        paper: palette.background?.paper,
      },
      text: {
        primary: palette.text?.primary,
        secondary: palette.text?.secondary,
        paper: palette.background?.paper,
      },
      divider: isDark ? '#2C2C2E' : 'rgba(0, 0, 0, 0.12)',
      ...(isDark && {
        grey: { light: '#2C2C2E', main: '#48484A', dark: '#8E8E93' },
      }),
    },
    ...getSharedConfig(mode),
  });
};

export const theme = getAppTheme('light');